import React, {useState, useEffect} from "react";
import './../Admin.css';
import logo from '../../assets/images/logo.png';
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import axios from 'axios';
import { apiUrl } from "../../config/Config";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

const AdminLogin = () => {
    const [username, setusername] = useState(null);
    const [password, setpassword] = useState();
    const [showloding, setshowloding] = useState(false);

    let navigate = useNavigate();
    const dispatch = useDispatch(); 
    const userdata = useSelector((store) => store.userReducer.userdata);

    console.log('userdata >>', userdata);

    const [file, setFile] = useState(null);
    
        const handleFileChange1 = (e) => {
          setFile(e.target.files[0]);
        };
      
        const testuploadppt = async() => {
          if (!file) {
            // setMessage("Please select a PPT file first.");
            return;
          }
          const formData = new FormData();
          formData.append("file", file); // "ppt" should match your API field name
          try {
            const response = await axios.post("https://snapglobaleservices.com/aranca/apibackend/apis/upload-ppt", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });
            console.log('response data >>', response);
      
            // setMessage("Upload successful: " + response.data.message);
          } catch (error) {
            // setMessage("Upload failed: " + error.message);
          }
        }
    
    
    
    const loginpressed = async() => {
      // navigate('/customer/home');
      if(username && password) {
        setshowloding(true);
        var data = {
            'username' : username,
            'password': password
        }
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        }
        let resp = await axios.post(apiUrl + 'adminlogin', data, headers).then((res) => {
            if(res.data.status == 'success') {
              dispatch({ type: "userdata", payload: res.data.data })
              navigate('/admin/all-layouts');
            } else {
              alert(res.data.message);
            }
        } ).catch((err) => {
            alert(err.message)
        })
        setshowloding(false);
    } else {
        alert('username and password is required');
    }
    }  

    useEffect(() => {
        if (userdata && Object.keys(userdata).length > 0) {
            //   fetchdata();
            // navigate("/users");
          } else {
          }
    }, [])

    return (
      <div className="loginBoxMaindiv">
        <div className="webloginBox">
          <img src={logo} />
          <div className="mb-3 mt-4">
            <label for="email" className="form-label">
              Username:
            </label>
            <input
              type="text"
              value={username}
              onChange={(t) => {
                setusername(t.target.value);
              }}
              className="form-control logininput"
              placeholder="Enter Username"
            />
          </div>
          <div className="mb-4">
            <label for="pwd" className="form-label">
              Password:
            </label>
            <input
              type="password"
              value={password}
              onChange={(t) => {
                setpassword(t.target.value);
              }}
              className="form-control logininput"
              id="pwd"
              placeholder="Enter password"
              name="pswd"
            />
          </div>
          <div className="mb-2">
            <button
              type="button"
              className="btn btn-primary webcustom-btn"
              onClick={() => {
                loginpressed();
              }}
            >
              {showloding ? (
                <Spinner color="#fff" size={15} className="spinnerCenter" />
              ) : (
                "LOGIN"
              )}
            </button>

            {/* <input
              type="file"
              accept=".pptx"
              // ref={fileInputRef}
              className="mt-3"
              onChange={handleFileChange1}
            ></input>

            <button
              type="button"
              className="btn btn-primary webcustom-btn"
              onClick={() => {
                testuploadppt();
              }}
            >
              {"UPLOAD PPT"}
            </button> */}
          </div>
        </div>
      </div>
    );
}

export default AdminLogin